import { APIClient } from "./_api";

const endpoint = "/Lang";

export function getAll() {
  return APIClient.get(`${endpoint}`);
}

// export function addProduct(data) {
//   return APIClient.post(`${endpoint}`, data);
// }

// export function editProduct(data, id) {
//   return APIClient.put(`${endpoint}/${id}`, data);
// }

// export function deleteProduct(id) {
//   return APIClient.delete(`${endpoint}/${id}`);
// }
